import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from './CookieConsent';
import TradingStatusBanner from './TradingStatusBanner';
import TranslationNotice from './TranslationNotice';
import BrandPreviewRibbon from './BrandPreviewRibbon';
import BootSplash from './BootSplash';
import ScrollToTop from './ScrollToTop';
import { LocaleProvider, useContent } from '../i18n/LocaleProvider';
import { getCached } from '../lib/api';

function SkipLink() {
  const { UI } = useContent();
  return (
    <a href="#main" className="c-skip-link">
      {UI.common.skipToContent}
    </a>
  );
}

export default function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [fracPublic, setFracPublic] = useState(false);

  useEffect(() => {
    // The single FRAC_PUBLIC flag in backend/.env is what reveals the nav item.
    getCached('/config')
      .then((data) => setFracPublic(Boolean(data.frac_public)))
      .catch(() => setFracPublic(false));
  }, []);

  useEffect(() => {
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  return (
    <LocaleProvider>
      <BootSplash />
      <SkipLink />
      <TradingStatusBanner />
      <TranslationNotice />
      <Header transparentOverHero={isHome} fracPublic={fracPublic} />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
      <CookieConsent />
      <BrandPreviewRibbon />
    </LocaleProvider>
  );
}
